import { LiteralExpression } from './LiteralExpression.js';
export class NumberExpression extends LiteralExpression {
    parseValue(value) {
        const val = typeof value === 'string' ? value.replace(/_/g, '') : value;
        if (!isNaN(+val)) {
            return +val;
        }
        else {
            throw new SyntaxError(`NumberExpression: '${value}' is not a Number!`);
        }
    }
}
//# sourceMappingURL=NumberExpression.js.map